import React from 'react';

function Next() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M0 24l17-12L0 0v24zM20 0v24h4V0h-4z" />
    </svg>
  );
  /* eslint-enable */
}

export default Next;



// WEBPACK FOOTER //
// ./src/common/icons/Next.js